import {CameraOptions, Camera} from '@ionic-native/camera';
import { Component, Input, ViewChild, ElementRef } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Platform, ActionSheetController } from 'ionic-angular';
import { Util } from '../../util/Util';

/**
 * Generated class for the UploadButtonComponent component.
 *
 * See https://angular.io/docs/ts/latest/api/core/index/ComponentMetadata-class.html
 * for more info on Angular Components.
 */



@Component({
  selector: 'upload-button',
  templateUrl: 'upload-button.html'
})

export class UploadButtonComponent {

  /**
   * The callback executed when button pressed, set by parent
   */
  @Input() btnStyle: String;

  /**
   * The callback executed when files are selected, set by parent
   */
  @Input() btnCallback: Function;
  @Input() isDisable?: boolean = false;
  @Input() maxImageWidth?: number;
  @Input() isCreateTips?: boolean = false;

  /**
   * Native upload button (hidden)
   */
  @ViewChild("input")
  private nativeInputBtn: ElementRef;
  private options: CameraOptions;
  canvasSize = 512;

  /**
   * Constructor
   * @param  {Renderer} renderer for invoking native methods
   * @param  {Log}      logger instance
   */
  constructor(private translateService: TranslateService, private camera: Camera, private platform: Platform, private actionSheetCtrl: ActionSheetController) {
    this.options = {
      quality: 80,
      sourceType: this.camera.PictureSourceType.PHOTOLIBRARY || this.camera.PictureSourceType.CAMERA,
      destinationType: this.camera.DestinationType.DATA_URL,
      encodingType: this.camera.EncodingType.PNG,
      mediaType: this.camera.MediaType.PICTURE,
      targetWidth: this.canvasSize,
      targetHeight: this.canvasSize,
      correctOrientation: true,
      allowEdit: false
    }
  }

  ngOnChanges() {
    // set the specified width (for resizing image)
    if (this.maxImageWidth != null && this.maxImageWidth != 0) {
      this.canvasSize = this.maxImageWidth;
    }
  }

  /**
   * Callback executed when the visible button is pressed
   * @param  {Event}  event should be a mouse click event
   */
  public callback(event: Event): void {
    // console.log("camera icon clicked!");
    if (this.isDisable) {
      return;
    }

    if (Util.isApp(this.platform)) {
      let actionSheetCtrl = this.actionSheetCtrl.create({
        title: this.translateService.instant("uploadImgTitle"),
        buttons: [
          {
            text: this.translateService.instant("uploadImgByCamera"),
            handler: () => {
              this.options.sourceType = this.camera.PictureSourceType.CAMERA;
              this.camera.getPicture(this.options).then(imageData => {
                let fixedOrientationBase64Img = 'data:image/png;base64,' + imageData;
                this.btnCallback(fixedOrientationBase64Img);
              }, err => {
                console.log(err);
              })
            }
          },
          {
            text: this.translateService.instant("uploadImgByPhotoLibrary"),
            handler: () => {
              this.options.sourceType = this.camera.PictureSourceType.PHOTOLIBRARY;
              this.camera.getPicture(this.options).then(imageData => {
                let fixedOrientationBase64Img = 'data:image/png;base64,' + imageData;
                this.btnCallback(fixedOrientationBase64Img);
              }, err => {
                console.log(err);
              })
            }
          },
          {
            text: this.translateService.instant("cancel"),
            role: "cancel"
          }
        ]
      });
      actionSheetCtrl.present();

    } else {
      // trigger click event of hidden input
      this.nativeInputBtn.nativeElement.click();
    }

  }

  /**
   * Callback which is executed after files from native popup are selected.
   * @param  {Event}    event change event containing selected files
   */
  public filesAdded(event: Event): void {
    // console.log("filesAdded! ", event);
    let files: FileList = this.nativeInputBtn.nativeElement.files;

    let maxWidth: number = this.canvasSize;
    // console.log("maxWidth: " + maxWidth + "||" + " canvasSize: " + this.canvasSize);
    // console.log("options: ", this.options);

    if (files.length > 0) {
      var img = document.createElement('img');
      var me = this;

      img.onload = function () {
        var srcFile = files[0];
        me.getOrientation(srcFile, function (orientation) {

          let canvas = document.createElement('canvas'),
            ctx = canvas.getContext("2d"),
            oc = document.createElement('canvas'),
            octx = oc.getContext('2d');

          canvas.width = maxWidth; // destination canvas size
          canvas.height = canvas.width * img.height / img.width;

          var cur = {
            width: Math.floor(img.width * 0.5),
            height: Math.floor(img.height * 0.5)
          }

          oc.width = cur.width;
          oc.height = cur.height;

          octx.drawImage(img, 0, 0, cur.width, cur.height);

          while (cur.width * 0.5 > maxWidth) {
            cur = {
              width: Math.floor(cur.width * 0.5),
              height: Math.floor(cur.height * 0.5)
            };
            octx.drawImage(oc, 0, 0, cur.width * 2, cur.height * 2, 0, 0, cur.width, cur.height);
          }

          ctx.drawImage(oc, 0, 0, cur.width, cur.height, 0, 0, canvas.width, canvas.height);

          // fix orientation
          me.resetOrientation(canvas.toDataURL(), orientation, function (fixedOrientationBase64Img) {
            me.btnCallback(fixedOrientationBase64Img);
            me.nativeInputBtn.nativeElement.value = null;
          })

        })
      }


      /* var canvas = document.createElement('canvas');
      var context = canvas.getContext('2d');
      var maxW = 512;
      var maxH = 512;
      var img = document.createElement('img');

      var me = this;
      img.onload = function() {
        var srcFile = files[0];
        me.getOrientation(srcFile, function(orientation) {
          // resize image
          var iw = img.width;
          var ih = img.height;
          var scale = Math.min((maxW / iw), (maxH / ih));
          var iwScaled = iw * scale;
          var ihScaled = ih * scale;
          canvas.width = iwScaled;
          canvas.height = ihScaled;
          context.drawImage(img, 0, 0, iwScaled, ihScaled);

          // fix orientation
          me.resetOrientation(canvas.toDataURL(), orientation, function(fixedOrientationBase64Img){
            me.btnCallback(fixedOrientationBase64Img);
            me.nativeInputBtn.nativeElement.value = null;
          })
        })
      } */



      img.onerror = function () {
        alert(me.translateService.instant("errorImageMsg"));
      }
      img.src = URL.createObjectURL(files[0]);
    } else {
      this.btnCallback(null);
      me.nativeInputBtn.nativeElement.value = null;
    }

  }

  getOrientation(file, callback) {
    var reader = new FileReader();
    reader.onload = function (e: any) {

      var view = new DataView(e.target.result);
      if (view.getUint16(0, false) != 0xFFD8) return callback(-2);
      var length = view.byteLength, offset = 2;
      while (offset < length) {
        var marker = view.getUint16(offset, false);
        offset += 2;
        if (marker == 0xFFE1) {
          if (view.getUint32(offset += 2, false) != 0x45786966) return callback(-1);
          var little = view.getUint16(offset += 6, false) == 0x4949;
          offset += view.getUint32(offset + 4, little);
          var tags = view.getUint16(offset, little);
          offset += 2;
          for (var i = 0; i < tags; i++)
            if (view.getUint16(offset + (i * 12), little) == 0x0112)
              return callback(view.getUint16(offset + (i * 12) + 8, little));
        }
        else if ((marker & 0xFF00) != 0xFF00) break;
        else offset += view.getUint16(offset, false);
      }
      return callback(-1);
    };
    reader.readAsArrayBuffer(file);
  }

  resetOrientation(srcBase64, srcOrientation, callback) {
    var img = new Image();

    img.onload = function () {
      var width = img.width,
        height = img.height,
        canvas = document.createElement('canvas'),
        ctx = canvas.getContext("2d");

      // set proper canvas dimensions before transform & export
      if ([5, 6, 7, 8].indexOf(srcOrientation) > -1) {
        canvas.width = height;
        canvas.height = width;
      } else {
        canvas.width = width;
        canvas.height = height;
      }

      // transform context before drawing image
      switch (srcOrientation) {
        case 2: ctx.transform(-1, 0, 0, 1, width, 0); break;
        case 3: ctx.transform(-1, 0, 0, -1, width, height); break;
        case 4: ctx.transform(1, 0, 0, -1, 0, height); break;
        case 5: ctx.transform(0, 1, 1, 0, 0, 0); break;
        case 6: ctx.transform(0, 1, -1, 0, height, 0); break;
        case 7: ctx.transform(0, -1, -1, 0, height, width); break;
        case 8: ctx.transform(0, -1, 1, 0, 0, width); break;
        default: ctx.transform(1, 0, 0, 1, 0, 0);
      }

      // draw image
      ctx.drawImage(img, 0, 0);

      // export base64
      callback(canvas.toDataURL());
    };

    img.src = srcBase64;
  };
}



// WEBPACK FOOTER //
// ./src/components/upload-button/upload-button.ts